import { Injectable, inject } from '@angular/core';
import { FlagKey, isFlagEnabled } from '../models/feature-flag.type';
import { MembershipService } from './auth/membership.service';

/** Evaluates feature flags for the clinic currently selected. */
@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private membership = inject(MembershipService);

  isEnabled(flag: FlagKey): boolean {
    return isFlagEnabled(this.membership.selectedBusinessFlags(), flag);
  }
}
